import LegacyComposerComponent from '@intercom/embercom-composer/components/legacy-composer';
export default LegacyComposerComponent.extend();